import React, { useEffect, useRef, useState, useMemo } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import { useTranslation } from 'react-i18next';
import { Button, Form, Input, Select, message } from 'antd';
import Axios from 'axios';
import cx from 'classnames';
import { useStore } from '@/models';
import CaptchaBtn from '@/components/captchaBtn';
import { getExchangeUrl } from '@/utils/location';
import SelectArrowIcon from '@/components/icons/SelectArrowIcon';
import EyeShowIcon from '@/components/icons/EyeShowIcon';
import EyeHideIcon from '@/components/icons/EyeHideIcon';
import cs from './index.module.scss';
import encrypt from '@/utils/encrypt';
import backcircle from '@/assets/common/backcircle.png';
import backIcon from '@/assets/common/backIcon.png';
import registerBg from '@/assets/img/register/registerBg.jpg';
import '@/lib/gt';
import EmailList from '../components/emailList';

const { Option } = Select;
const FindPsw: React.FC = () => {
  const { t } = useTranslation();
  const { account, ui } = useStore();
  const inputRef = useRef(null);
  const inputRefRepeat = useRef(null);

  const { loginOut, lang, countryList, fetchReset, fetchInit, fetchisExit, setGeeResult, judgeToken } = account;
  const [currentTab, setCurrentTab] = useState('email');
  const [isNext, setIsNext] = useState(false);
  const [msg, setMsg] = useState('');
  const [code, setCode] = useState(0);
  const [showPsw, setShowPsw] = useState(false); // 展示密码
  const [showRepeatPsw, setShowRepeatPsw] = useState(false); // 展示密码

  const [userNameProp, setUserNameProp] = useState('');
  const [showEmailList, setShowEmailList] = useState(false);

  const [type, setType] = useState('');
  const captchaObj = useRef<any>(null);
  const verifyPhone = useMemo(() => [-10024, -10022, -10026, -10027].includes(code), [code]);
  const verifyEmail = useMemo(() => [-10021, -10025, -10026, -10027].includes(code), [code]);
  const verifyGoogle = useMemo(() => [-10023, -10024, -10027, -10025].includes(code), [code]);

  const [form] = Form.useForm();
  const { push } = useHistory();



  useEffect(() => {
    inputRef.current?.focus({
      cursor: 'end',
    });
  }, [showPsw]);
  useEffect(() => {
    inputRefRepeat.current?.focus({
      cursor: 'end',
    });
  }, [showPsw]);
  const handleCurrentTab = (value: string) => {
    form.resetFields();
    setCurrentTab(value);
  };
  const isExit = geetest => {
    setGeeResult(geetest);
    const params = {
      userName: form.getFieldValue('username'),
      countryCode: form.getFieldValue('telCountryCode'),
      geetest: JSON.stringify(geetest),
    };
    fetchisExit(params)
      .then(res => {
        if (!res) return;
        const { exist, judgeToken } = res;
        if (exist) {
          const data = {
            username: form.getFieldValue('username'),
            telCountryCode: form.getFieldValue('telCountryCode'),
            judgeToken,
          };
          fetchReset(data).then(result => {
            if (result) {
              setCode(result?.code);
              setMsg(result?.msg);
              setIsNext(true);
            }
          });
        } else {
          message.error(t('findpsw.noexit'));
        }
      })
      .finally(() => {
        // setLoading(false);
      });
  };
  useEffect(() => {
    fetchInit().then(res => {
      if (res) {
        if (!res?.new_captcha) return;
        setType(res?.type);
        if (res?.type === 'neteasy') {
          initNECaptcha(
            {
              captchaId: res.gt,
              element: '#elementId',
              mode: 'popup',
              width: '320px',
              apiVersion: 2,
              lang: lang === 'zh' ? 'zh-CN' : 'en',
              popupStyles: {
                position: 'fixed',
                top: '20%',
                // top: '100px',
                // right: '50px',
              },
              onVerify: (err, data) => {
                // 当验证失败时, 内部会自动 refresh 方法, 无需手动再调用一次
                if (err) return;
                // 以下为业务侧逻辑
                isExit(data);
                // captchaObj.current && captchaObj.current.refresh();
              },
              onClose: () => {
                captchaObj.current && captchaObj.current.refresh();
              },
            },
            instance => {
              captchaObj.current = instance;
              // setCaptchaObj(instance);
            },

            err => {
              // 初始化失败后触发该函数, err 对象描述当前错误信息
              console.log(err, 'err');
            },
          );

          // document.querySelector('#elementId').addEventListener('click', () => {
          //   captchaObj && captchaObj.verify();
          // });
        } else if (res?.type === 'aliyun') {
          initAlicom4(
            {
              captchaId: res.gt,
              product: 'bind',
              language: lang === 'zh' ? 'zho' : 'eng',
            },
            captcha => {
              captchaObj.current = captcha;
              // captcha为验证码实例
              // setCaptchaObj(captcha);
              captcha
                .onReady(() => {
                  // 验证码ready之后才能调用verify方法显示验证码
                })
                .onSuccess(() => {
                  const result = captcha.getValidate();

                  isExit({ ...result, graphicType: 'GEETEST' });
                })
                .onClose(() => {
                  setLoading(false);
                })
                .onError(() => {
                  // your code
                });
            },
          );
          return;
        } else {
          initGeetest4(
            {
              captchaId: res.gt,
              product: 'bind',
              language: lang === 'zh' ? 'zho' : 'eng',
            },
            captcha => {
              captchaObj.current = captcha;
              // captcha为验证码实例
              // setCaptchaObj(captcha);
              captcha
                .onReady(() => {
                  // 验证码ready之后才能调用verify方法显示验证码
                })
                .onSuccess(() => {
                  const result = captcha.getValidate();

                  isExit(result);
                  // if (!result) {
                  //   return alert('请完成验证');
                  // }
                })
                .onError(() => {
                  // your code
                });
            },
          );
        }
      }
    });
  }, []);
  const prefixSelector = (
    <Form.Item name="telCountryCode" noStyle>
      <Select
        optionLabelProp="label"
        dropdownMatchSelectWidth={false}
        suffixIcon={<SelectArrowIcon />}
        className="selectNormal"
      >
        {countryList?.map((_: any) => (
          <Option value={_.code} key={_.id} label={`+${_.code}`} className="option">
            +{_.code} {lang === 'zh' ? _.zh : _.en}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
  const onFinish = (values: any) => {
    if (type === 'neteasy') {
      captchaObj.current && captchaObj.current.verify();
    } else {
      captchaObj.current && captchaObj.current.showCaptcha();
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };
  const onFinishSecond = (values: any) => {
    const { telCountryCode, repeatPassword, newPassword, googleCode, emailCode, phoneCode } = values;
    const data = {
      prefixAuth: msg,
      repeatPassword: encrypt(repeatPassword),
      telCountryCode,
      newPassword: encrypt(newPassword),
      googleCode,
      emailCode,
      phoneCode,
    };
    setIsNext(true);
    Axios.post(getExchangeUrl().resetSuffix, data)
      .then(res => {
        message.success(t('common.resetpsdsuccess'));
        loginOut();
        // push(`/`);
        ui.hideFindPwdModal();
        ui.showLoginModal();
      })
      .catch(err => {
        message.error(err.msgInfo);
      });
  };
  const onFinishFailedSecond = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };
  const back = () => {
    setIsNext(false);
  };

  useEffect(() => {
    form.setFieldsValue({ username: userNameProp });
  }, [userNameProp]);
  return (
    <div
      className={cs.container}
      onClick={() => {
        ui.hideFindPwdModal();
      }}
    >
      <div
        className={cs.contentBox}
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className={cs.content}>
          <div className={cx(cs.title, 'flex align-items-center')}>
            {isNext && <img src={backIcon} alt="" onClick={back} />}
            {t('common.resetpsd1')}
          </div>
          <div className={cx(cs.content_info)}>
            {/* {isNext ? null : (
              <div className={cs.tab}>
                <span onClick={() => handleCurrentTab('email')} className={currentTab === 'email' ? cs.active : ''}>
                  {t('common.email')}
                </span>
                <span className={currentTab === 'phone' ? cs.active : ''} onClick={() => handleCurrentTab('phone')}>
                  {t('common.tel')}
                </span>
              </div>
            )} */}
            {isNext ? (
              <Form
                form={form}
                name="basic"
                labelCol={{ flex: 1 }}
                wrapperCol={{ flex: 1 }}
                labelAlign="left"
                initialValues={{ telCountryCode: '86' }}
                onFinish={onFinishSecond}
                onFinishFailed={onFinishFailedSecond}
                autoComplete="off"
                layout="vertical"
                requiredMark={false}
              >
                {verifyPhone ? (
                  <Form.Item
                    // label={t('common.sjyzm')}
                    name="phoneCode"
                    rules={[{ required: true, message: t('common.srsjyzm') }]}
                  >
                    <Input
                      className="bgIptAddonAfter"
                      placeholder={t('common.srsjyzm')}
                      addonAfter={
                        <CaptchaBtn username={userNameProp} telCountryCode={form.getFieldValue('telCountryCode')} />
                      }
                    />
                  </Form.Item>
                ) : null}
                {verifyEmail ? (
                  <Form.Item
                    // label={t('common.yxyam')}
                    name="emailCode"
                    rules={[{ required: true, message: t('common.qsryxyzm') }]}
                  >
                    <Input
                      className="bgIptAddonAfter"
                      placeholder={t('common.qsryxyzm')}
                      addonAfter={
                        <CaptchaBtn username={userNameProp} telCountryCode={form.getFieldValue('telCountryCode')} />
                      }
                    />
                  </Form.Item>
                ) : null}
                {verifyGoogle ? (
                  <Form.Item
                    // label={t('common.AuthenticationCode')}
                    name="googleCode"
                    rules={[{ required: true, message: t('common.AuthenticationCodePlace') }]}
                  >
                    <Input placeholder={t('common.AuthenticationCodePlace')} className="iptDefault" />
                  </Form.Item>
                ) : null}
                <Form.Item
                  // label={t('common.newloginpsd')}
                  name="newPassword"
                  rules={[
                    // { required: true, message: t('common.enterpsd') },
                    { min: 8, max: 22, message: t('common.psdrule') },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        // if (value.trim() === '') {
                        //   return Promise.reject(new Error(t('common.enterpsd')));
                        // }
                        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~\\-])[A-Za-z\d!@#$%^&*()_+{}\[\]:;<>,.?~\\-]{8,20}$/;
                        if (!regex.test(String(value))) {
                          return Promise.reject(new Error(t('common.psdregex')));
                        }
                        return Promise.resolve();
                      },
                    }),
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (value.length >= 8 && value.length <= 22) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error(t('common.psdrule')));
                      },
                    }),
                  ]}
                >
                  <Input
                    placeholder={t('common.newpsdPlace')}
                    ref={inputRef}
                    type={showPsw ? 'text' : 'password'}
                    className="iptSuffix"
                    maxLength={22}
                    suffix={
                      showPsw ? (
                        <EyeShowIcon
                          onClick={() => {
                            setShowPsw(!showPsw);
                          }}
                        />
                      ) : (
                        <EyeHideIcon
                          onClick={() => {
                            setShowPsw(!showPsw);
                          }}
                        />
                      )
                    }
                  />
                </Form.Item>
                <Form.Item
                  // label={t('common.confirmloginpsd')}
                  name="repeatPassword"
                  dependencies={['newPassword']}
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value) return Promise.reject(new Error(t('common.againpsd')));
                        if (!value || getFieldValue('newPassword') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error(t('common.psddif')));
                      },
                    }),
                  ]}
                >
                  <Input
                    placeholder={t('common.newpsdPlace1')}
                    ref={inputRefRepeat}
                    type={showRepeatPsw ? 'text' : 'password'}
                    className="iptSuffix"
                    maxLength={22}
                    suffix={
                      showRepeatPsw ? (
                        <EyeShowIcon
                          onClick={() => {
                            setShowRepeatPsw(!showRepeatPsw);
                          }}
                        />
                      ) : (
                        <EyeHideIcon
                          onClick={() => {
                            setShowRepeatPsw(!showRepeatPsw);
                          }}
                        />
                      )
                    }
                  />
                </Form.Item>

                <Button
                  type="primary"
                  htmlType="submit"
                  className={cx('btnPrimary', cs.registerBtn)}
                  style={{ height: '40px', width: '100%', margin: '24px 0' }}
                >
                  {t('btn.confirm')}
                </Button>
              </Form>
            ) : (
              <Form
                form={form}
                name="basic"
                labelCol={{ flex: 1 }}
                wrapperCol={{ flex: 1 }}
                labelAlign="left"
                initialValues={{ telCountryCode: '86' }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                layout="vertical"
                requiredMark={false}
              >
                {currentTab === 'phone' ? (
                  <Form.Item
                    // label={t('common.sjhm')}
                    name="username"
                    rules={[{ required: true, message: t('common.srsjhm') }]}
                  >
                    {/* allowClear={{ clearIcon: chaCom }} */}
                    <Input
                      className="bgIptAddonBefore"
                      addonBefore={prefixSelector}
                      placeholder={t('common.srsjhm')}
                      onChange={e => {
                        setUserNameProp(e.target.value);
                      }}
                    />
                  </Form.Item>
                ) : (
                  <Form.Item
                    // label={t('common.email')}
                    name="username"
                    rules={[{ required: true, type: 'email', message: t('common.srzqdyxgs') }]}
                  >
                    <>
                      <Input
                        className="iptDefault"
                        placeholder={t('common.emailPlace')}
                        onChange={e => {
                          setUserNameProp(e.target.value);
                        }}
                        value={userNameProp}
                        onFocus={() => setShowEmailList(true)} // 🔹 聚焦时显示
                        onBlur={() => setTimeout(() => setShowEmailList(false), 200)} // 🔹 失焦时隐藏（延迟避免点击列表时消失）
                      />
                      {showEmailList && userNameProp && (
                        <EmailList
                          curValue={String(userNameProp)}
                          chooseEmail={selectedEmail => setUserNameProp(selectedEmail)}
                        />
                      )}
                    </>
                  </Form.Item>
                )}

                <Button
                  type="primary"
                  htmlType="submit"
                  className={cx('btnPrimary', cs.registerBtn)}
                  style={{ height: '40px', width: '100%', margin: '0 0 24px 0' }}
                >
                  {t('common.next')}
                </Button>
              </Form>
            )}
            <div
              className={cx(cs.toReg, 'pointer')}
              onClick={() => {
                // push('/register');
                ui.hideFindPwdModal();
                ui.showRegisterModal();
              }}
            >
              <span>{t('signIn.noAccount')}</span>

              <span className={cx('pointer', 'text-primary', 'font-700')}>{t('btn.signUpNow')}</span>
            </div>
          </div>
        </div>
        <div className={cs.left}>
          {/* <span> {t('signUp.title')}</span> */}
          <img src={registerBg} alt="" />
        </div>
      </div>
    </div>
  );
};

export default observer(FindPsw);
